export enum SectionType {
  GENERAL = 'general',
  FEEDSTOCK = 'feedstock',
  MEMBERS = 'members',
  PLANTSPEC = 'plantspec',
  FINANCIAL = 'financial'
}
